import React, { Suspense, lazy } from 'react';
import { isModernUi } from './config/uiMode';

// Each application is loaded lazily so the inactive one — including its
// global CSS — is never downloaded or applied.
const SelectedApp = isModernUi
  ? lazy(() => import('./modern/App'))
  : lazy(() => import('./App'));

const AppRoot = () => (
  <Suspense fallback={null}>
    <SelectedApp />
  </Suspense>
);

export default AppRoot;
